/**
 * PRpillar fork: the "Code" chart type (`custom_code`).
 *
 * The chart author writes an HTML document; the frontend renders it in a
 * sandboxed iframe (no same-origin, no network) and hands it the chart's
 * query results through a MessageChannel. The config lives in the chart's
 * `chart_config` jsonb, so no migration is needed.
 */
/** Hard limit for the component source, in bytes (UTF-8). */
export const CUSTOM_CODE_SOURCE_MAX_BYTES = 256 * 1024;
/** Limit for one message the component sends to the host, in bytes. */
export const CUSTOM_CODE_MESSAGE_MAX_BYTES = 64 * 1024;
/**
 * Project default (`project_defaults.custom_code_charts`) that turns the
 * chart type on for a project. Off unless set to true.
 */
export const CUSTOM_CODE_PROJECT_DEFAULT_KEY = 'custom_code_charts';
export const getUtf8ByteLength = (value) => new TextEncoder().encode(value).length;
export const isCustomCodeSourceTooLarge = (source) => !!source && getUtf8ByteLength(source) > CUSTOM_CODE_SOURCE_MAX_BYTES;
export const isCustomCodeChartsEnabled = (projectDefaults) => projectDefaults?.custom_code_charts === true;
//# sourceMappingURL=customCodeChart.js.map